import { DataVisualizationType } from "components/charting/config/chartTypes";
import { createContext } from "react";

const SetDataVisualizationTypeContext = createContext<undefined | ((type: DataVisualizationType) => void)>(undefined);

export default SetDataVisualizationTypeContext;
